// @ts-nocheck
import RhfInput from "@/components/rhfFields/RhfInput";
import RHFWrapper from "@/components/RHFWrapper";
import {
  FormField,
  FormControl,
  FormItem,
  FormLabel,
  FormMessage,
} from "@/components/ui/form";
import { useFormContext, useWatch } from "react-hook-form";
import { Button } from "@/components/ui/button";
import {
  Card,
  CardContent,
  CardDescription,
  CardHeader,
  CardTitle,
} from "@/components/ui/card";
import { Input } from "@/components/ui/input";
import { PhoneInput } from "@/components/ui/input-phone";
import { Label } from "@/components/ui/label";
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "@/components/ui/select";
import { normalizeAuthPayload, useAuth } from "@/contexts/use-auth";
import AxiosInstance from "@/utils/AxiosInstance";
import { getErrToast, getPromise, getPromiseToast } from "@/utils/helpers";
import { AuthSchema } from "@/utils/ValidataionSchemas";
import {
  Shield,
  HeartHandshake,
  ArrowLeft,
  User,
  Stethoscope,
  ArrowBigLeft,
  EyeClosed,
  EyeIcon,
  UserCircle,
  Pencil,
  AlertCircle,
} from "lucide-react";
import { Tabs, TabsList, TabsTrigger } from "@/components/ui/tabs";
import { Suspense, useEffect, useState } from "react";
import { useNavigate } from "react-router";
import { toast } from "sonner";
import { Dialog } from "@/components/ui/dialog";
import MyDialogContent from "@/components/MyDialogContent";
import TermsConditionsDialog from "@/components/TermsDialog";
import { Checkbox } from "@/components/ui/checkbox";

interface AuthProps {
  redirectAfterAuth?: string;
}

type UserRole = "admin" | "provider" | "caretaker" | "patient";
import * as yup from "yup";
import { is } from 'date-fns/locale';
import {
  resolveLoggedType,
  writeLoggedType,
  writeUserSwitchSessionData,
} from "@/types/linkedProfile";

const OtherAuthSchema = yup.object({
  email: yup
    .string()
    .trim()
    .required( "Email is required")
    .email("Email must be valid"),
  password: yup
    .string()
    .required("Password is required")
    .min(8, 'Password should be greater than 8'),
});

function PatientEmailOrPhoneField({
  className,
  isPhoneField = false,
  dissableField = false,
  showEditButton = false,
  onEdit,
}: {
  className?: string;
  isPhoneField?: boolean;
  dissableField?: boolean;
  showEditButton?: boolean;
  onEdit?: () => void;
}) {
  const { control } = useFormContext();
  return (
    <FormField
      control={control}
      name="email"
      render={({ field }) => {
        const raw = String(field.value || "");
        const digits = raw.replace(/\D/g, "");
        const isPhone = isPhoneField
          ? true
          :  digits.length >= 9 && !raw.includes("@") && !/[a-zA-Z]/.test(raw);
        return (
          <FormItem className={className}>
            <FormLabel>
              {isPhoneField ? "Mobile" : "Email or Mobile"} *
            </FormLabel>
            <FormControl>
              <div className="flex items-center gap-2">
                {(isPhone || isPhoneField) && (
                  <div className="h-10 px-3 inline-flex items-center rounded-md border bg-muted text-sm font-medium">
                    +1
                  </div>
                )}
                <Input
                  {...field}
                  value={field.value ?? ""}
                  disabled={showEditButton}
                  onChange={(e) => {
                    const v = e.target.value;
                    if (isPhoneField) {
                      const digitsOnly = v.replace(/\D/g, "");
                      if (digitsOnly.length === 0) {
                        field.onChange("");
                        return;
                      }
                      if (digitsOnly.length <= 10) {
                        field.onChange(digitsOnly);
                        return;
                      }
                      if (digitsOnly.length === 11 && digitsOnly[0] === "1") {
                        field.onChange(digitsOnly.slice(1));
                        return;
                      }
                      field.onChange(digitsOnly.slice(0, 10));
                      return;
                    }
                    // Email: allow letters, @, dots, etc.
                    if (v.includes("@") || /[a-zA-Z]/.test(v)) {
                      field.onChange(v?.trim() ?? "");
                      return;
                    }
                    // Phone: only digits (and strip to 10)
                    const digitsOnly = v.replace(/\D/g, "");
                    if (digitsOnly.length === 0) {
                      field.onChange("");
                      return;
                    }
                    if (digitsOnly.length <= 10) {
                      field.onChange(digitsOnly);
                      return;
                    }
                    if (digitsOnly.length === 11 && digitsOnly[0] === "1") {
                      field.onChange(digitsOnly.slice(1));
                      return;
                    }
                    field.onChange(digitsOnly.slice(0, 10));
                  }}
                  onBlur={field.onBlur}
                  placeholder={
                    isPhoneField
                      ? "Enter mobile number"
                      : "Enter email or mobile number"
                  }
                  autoComplete="username"
                  className="flex-1"
                />
                {showEditButton && (
                  <Button
                    type="button"
                    variant="default"
                    size="sm"
                    onClick={onEdit}
                    className="px-2"
                  >
                    <Pencil />
                  </Button>
                )}
              </div>
            </FormControl>
            <FormMessage />
          </FormItem>
        );
      }}
    />
  );
}

function PatientSendOtpAction({
  onSendOtp,
  isSending,
  disabled,
  hasLoginConsent
}: {
  onSendOtp: (contact: string) => void;
  isSending: boolean;
  disabled: boolean;
  hasLoginConsent: boolean
}) {
  const { watch } = useFormContext();
  // console.log("dissabeld", disabled);
  const contact = String(watch("email") || "").trim();
  const digits = contact.replace(/\D/g, "");
  const isPhone = digits.length >= 10;

  // if (!isPhone) {
  //   return null;
  // }
  let isDisabled = 
disabled || isSending || contact.length === 0 || !isPhone || !hasLoginConsent;
  return (
    <div className="flex justify-end m-0">
      <Button
        type="button"
        variant="default"
        className="w-full"
        disabled={isDisabled}
        onClick={() => onSendOtp(contact)}
      >
        {isSending ? "Sending Passcode..." : "Send Passcode"}
      </Button>
    </div>
  );
}

function PatientOtpFields({
  onSendOtp,
  isSending,
  disabled,
  // isOtpSent,
  loginViaPass,
  loginAs,
  setLoginViaPass,
  onEditContact,
  isOtpSent,
}: {
  onSendOtp: (contact: string) => void;
  isSending: boolean;
  disabled: boolean;
  loginViaPass: boolean;
  // isOtpSent: boolean;
  loginAs: "patient" | "provider";
  setLoginViaPass: React.Dispatch<React.SetStateAction<boolean>>;
  onEditContact: () => void;
  isOtpSent: boolean;
}) {
  const { watch } = useFormContext();
  const contact = String(watch("email") || "").trim();
  const digits = contact.replace(/\D/g, "");
  // this phone filed only helps other except the  PatientEmailOrPhoneField 
  const isPhone = digits.length >= 10 && !contact.includes("@") && !/^[a-zA-Z]/.test(contact);

  if(digits.length === 0) {
       setLoginViaPass(true);
  }

  return (
    <>
      <PatientEmailOrPhoneField
        isPhoneField={( loginViaPass ) ? false : true}
        className={loginViaPass ? "" : "mb-2"}
        showEditButton={!loginViaPass && isOtpSent}
        onEdit={onEditContact}

      />

      {isPhone && loginAs === "patient" && (
        <Tabs
          value={loginViaPass ? "password" : "otp"}
          onValueChange={(v) => setLoginViaPass(v === "password")}
          className="w-full"
        >
          <TabsList className="grid w-full grid-cols-2">
            <TabsTrigger value="password">Password</TabsTrigger>
            <TabsTrigger value="otp">Passcode</TabsTrigger>
          </TabsList>
        </Tabs>
      )}
      {/* { !isOtpSent &&
      <PatientSendOtpAction
        onSendOtp={onSendOtp}
        isSending={isSending}
        disabled={disabled}
      />
      } */}
    </>
  );
}

function SignInButton({
  isLoading,
  isForgetPassword,
  hasLoginConsent,
  lastSubmittedPassword,
}: {
  isLoading: boolean;
  isForgetPassword: boolean;
  hasLoginConsent: boolean;
  lastSubmittedPassword: { password: string; email: string } | null;
}) {
  const password = useWatch({ name: "password" });
  const email = useWatch({ name: "email" });
  const samePassword =
    !isForgetPassword &&
    lastSubmittedPassword !== null &&
    password === lastSubmittedPassword.password &&
    String(email ?? "").trim() === lastSubmittedPassword.email;

  return (
    <Button
      type="submit"
      variant="default"
      size="lg"
      disabled={
        isLoading ||
        (!isForgetPassword && !hasLoginConsent) ||
        samePassword
      }
      className="w-full"
    >
      {isForgetPassword ? "Send Reset Link" : "Sign in"}
    </Button>
  );
}

function Auth({ redirectAfterAuth }: AuthProps = {}) {
  const { isLoading: authLoading, isAuthenticated, signIn , setUserSwitchSessionData } = useAuth();
  const navigate = useNavigate();
  const [isLoading, setIsLoading] = useState(false);
  const [isShowPassword, setIsShowPassword] = useState(false);
  const [isTermsOpen, setIsTermsOpen] = useState(false);
  const [userData, setUserData] = useState({
    user: null,
    role: null,
    token: null,
    permissions: null,
    profile: null,
  });
  const [isForgetPassword, setIsForgetPAss] = useState(false);
  const [loginAs, setLoginAs] = useState<"patient" | "other">("other");
  const [hasLoginConsent, setHasLoginConsent] = useState(true);
  const [patientContact, setPatientContact] = useState("");
  const [patientOtp, setPatientOtp] = useState("");
  const [isOtpSent, setIsOtpSent] = useState(false);
  const [isSendingOtp, setIsSendingOtp] = useState(false);
  const [isVerifyingOtp, setIsVerifyingOtp] = useState(false);
  const [otpRequestId, setOtpRequestId] = useState<string | null>(null);
  const [resendAttempt, setResendAttempt] = useState(0);
  const [resendAvailableIn, setResendAvailableIn] = useState(0);
  const [loginViaPass, setLoginViaPass] = useState(true);
  const [error , setError] = useState("");
  const [lastSubmittedPassword, setLastSubmittedPassword] = useState<{password : string , email : string} | null>(null);

  function handleEditContact() {
    setIsOtpSent(false);
    setResendAvailableIn(0);
    setResendAttempt(0);
    setOtpRequestId(null);
  }

  useEffect(() => {
    if (!authLoading && isAuthenticated) {
      const redirect = redirectAfterAuth || "/dashboard";
      navigate(redirect);
    }
  }, [authLoading, isAuthenticated, navigate, redirectAfterAuth]);

  async function handleLogin(formData) {
    const password = String(formData["password"] ?? "");
    const email = String(formData["email"] ?? "").trim();
    if (
      !isForgetPassword &&
      lastSubmittedPassword !== null &&
      password === lastSubmittedPassword.password &&
      email === lastSubmittedPassword.email
    ) {
      return;
    }
    const { pr, rejectFn, resolveFn } = getPromise();
    getPromiseToast(pr);
    try {
      setIsLoading(true);
      if (isForgetPassword) {
        await AxiosInstance().post("/auth/forgot-password", {
          email,
        });
        resolveFn("Password reset link sent...");
        setError("");
        return;
      }

      const newUser = {
        email,
        password,
        consent: hasLoginConsent,
      };
      const { data } = await AxiosInstance().post("/auth/login", newUser);
      const loggedType = resolveLoggedType(email, {
        loginAsOther: loginAs === "other",
        apiType: data?.data?.type,
      });
      writeLoggedType(loggedType);
      console.log("data" , data.data.linkedProfiles);
      // Check if data has linked profiles then go with this flow.
      if (data?.data?.linkedProfiles && data?.data?.linkedProfiles?.length > 1) {
        resolveFn("Found Multiple Accounts. Please select one.");
        writeUserSwitchSessionData({
          token: data?.data?.token,
          linkedProfiles: data?.data?.linkedProfiles,
          loggedType,
          // user: data.data.user,
        });
        setUserSwitchSessionData({
          token: data.data.token,
          linkedProfiles: data.data.linkedProfiles,
          loggedType,
        });
        navigate("/user-switch" , {replace: true});
        return;
      }


      if (
        !data?.data?.user?.hasGivenConsent &&
        data?.data?.user?.role === "patient"
      ) {
        setIsTermsOpen(true);
        setUserData({
          user: data?.data?.user,
          role: data?.data?.user?.role,
          token: data?.data?.token,
          permissions: data?.data?.permissions,
          profile: data?.data?.profile,
        });
      } else {
        const session = normalizeAuthPayload(data);
        await signIn(
          { ...session.user, role: session.user?.role || "admin" },
          session.token,
          session.permissions,
          session.profile,
        );
      }
      resolveFn("Login sucessfully...");
      setError("");

    } catch (error) {
      console.log(
        "Login error:",
        error?.response?.data?.message || error?.message || "Login err",
      );
      rejectFn(error);
      if (!isForgetPassword) setLastSubmittedPassword({ password, email });
      setError(error?.response?.data?.message || error?.message || "Login error please try again");
    } finally {
      setIsLoading(false);
    }
  }

  const resendSchedule = [30, 60, 120, 300];

  useEffect(() => {
    if (!isOtpSent) {
      setResendAttempt(0);
      setResendAvailableIn(0);
      return;
    }

    if (resendAvailableIn <= 0) {
      return;
    }

    const timerId = window.setInterval(() => {
      setResendAvailableIn((prev) => (prev > 0 ? prev - 1 : 0));
    }, 1000);

    return () => window.clearInterval(timerId);
  }, [isOtpSent, resendAvailableIn]);

  function startResendCountdown(nextAttempt: number) {
    const delay = resendSchedule[nextAttempt];
    setResendAttempt(nextAttempt);
    setResendAvailableIn(delay ?? 0);
  }

  function formatCountdown(seconds: number) {
    const m = Math.floor(seconds / 60)
      .toString()
      .padStart(2, "0");
    const s = Math.floor(seconds % 60)
      .toString()
      .padStart(2, "0");
    return `${m}:${s}`;
  }

  async function handleSendPatientOtp(contact: string, isResend = false) {
    if (!contact) {
      getErrToast("Please enter an email or mobile number");
      return;
    }

    const { pr, rejectFn, resolveFn } = getPromise();
    getPromiseToast(pr);
    try {
      setIsSendingOtp(true);
      const identifier = formatOtpIdentifier(contact);
      setPatientContact(identifier);
      const { data } = await AxiosInstance().post("/auth/otp/request", {
        identifier,
      });
      const requestId = data?.data?.requestId || data?.requestId;
      const isSuccess = Boolean(data?.success ?? data?.data?.success);
      if (!requestId && !isSuccess) {
        throw new Error("Passcode request failed");
      }
      setOtpRequestId(requestId ?? null);
      setIsOtpSent(true);
      if (isResend) {
        startResendCountdown(resendAttempt + 1);
      } else {
        startResendCountdown(0);
      }
      resolveFn("Passcode sent successfully...");
      setError("");
    } catch (error) {
      rejectFn("Passcode request failed please try again after some time.");
    } finally {
      setIsSendingOtp(false);
    }
  }

  function handleResendOtp() {
    if (resendAttempt >= resendSchedule.length) {
      return;
    }
    handleSendPatientOtp(patientContact, true);
  }

  async function handleVerifyPatientOtp() {
    if (!otpRequestId) {
      getErrToast("Please request an Passcode first");
      return;
    }
    if (!patientOtp || patientOtp.length < 6) {
      getErrToast("Please enter the 6-digit Passcode");
      return;
    }

    const { pr, rejectFn, resolveFn } = getPromise();
    getPromiseToast(pr);
    try {
      setIsVerifyingOtp(true);
      const { data } = await AxiosInstance().post("/auth/otp/verify", {
        requestId: otpRequestId,
        code: patientOtp,
        platform: "web",
      });
      const loggedType = resolveLoggedType(patientContact, {
        apiType: data?.data?.type,
      });
      writeLoggedType(loggedType);
      // console.log({data});

      // Check if data has linked profiles then go with this flow.
      if (data?.data?.linkedProfiles && data?.data?.linkedProfiles?.length > 1) {
        resolveFn("Found Multiple Accounts. Please select one.");
        writeUserSwitchSessionData({
          token: data.data.token,
          linkedProfiles: data.data.linkedProfiles,
          loggedType,
          // user: data.data.user,
        });
        setUserSwitchSessionData({
          token: data.data.token,
          linkedProfiles: data.data.linkedProfiles,
          loggedType,
        });
        navigate("/user-switch" , {replace: true});
        return;
      }

      if (
        !data?.data?.user?.hasGivenConsent &&
        data?.data?.user?.role === "patient"
      ) {
        setIsTermsOpen(true);
        setUserData({
          user: data?.data?.user,
          role: data?.data?.user?.role,
          token: data?.data?.token,
          permissions: data?.data?.permissions,
          profile: data?.data?.profile,
        });
      } else {
        const session = normalizeAuthPayload(data);
        await signIn(
          { ...session.user, role: session.user?.role || "admin" },
          session.token,
          session.permissions,
          session.profile,
        );
      }
      resolveFn("Passcode verified successfully...");
    } catch (error) {
      rejectFn(error);
    } finally {
      setIsVerifyingOtp(false);
    }
  }

  function formatOtpIdentifier(raw: string) {
    const trimmed = raw.trim();
    if (trimmed.includes("@")) {
      return trimmed;
    }
    const digits = trimmed.replace(/\D/g, "");
    if (digits.length === 10) {
      return `+1${digits}`;
    }
    if (digits.length === 11 && digits.startsWith("1")) {
      return `+${digits}`;
    }
    if (trimmed.startsWith("+")) {
      return trimmed;
    }
    return trimmed;
  }

  async function handleAgreeTerms() {
    try {
      const { data } = await AxiosInstance().post(
        "/auth/update-consent",
        {},
        {
          headers: {
            Authorization: `Bearer ${userData?.token}`,
          },
        },
      );
      await signIn(
        { ...userData?.user, role: userData?.role },
        userData?.token,
        userData?.permissions,
        // userData?.profile,
        // userData?.linkedProfiles,
      );
    } catch (error) {
      getErrToast(error);
    }
  }

  console.log({ isOtpSent })

  return (
    <>
      <div className="min-h-dvh flex flex-col ">
        <div className="flex-1 flex items-center justify-center p-4">
          <Card className="w-full max-w-lg pb-0 border shadow-md relative">
            <CardHeader className="text-center">
              <div className="flex justify-center overflow-hidden">
                <img
                  src="/logo.png"
                  alt="Anthro Care Logo"
                  className="h-16 w-auto max-w-[220px] object-contain cursor-pointer"
                  onClick={() => navigate("/")}
                />
              </div>
              <CardTitle className="text-2xl">Welcome to Anthro Care</CardTitle>
              <CardDescription className="pt-1">
                Who is logging in?
              </CardDescription>
            </CardHeader>
            <CardContent className="pb-6">
              <Tabs
                value={loginAs}
                onValueChange={(v) => {setLoginAs(v as "patient" | "other"); setLoginViaPass(true);  }}
                className="w-full mb-6"
              >
                <TabsList className="grid w-full grid-cols-2">
                  <TabsTrigger value="patient" className="gap-2">
                    <UserCircle className="h-4 w-4" />
                    Patient
                  </TabsTrigger>
                  <TabsTrigger value="other" className="gap-2">
                    <Stethoscope className="h-4 w-4" />
                    Other
                  </TabsTrigger>
                </TabsList>
              </Tabs>
              {/* <form onSubmit={handleLogin} className="space-y-6">
              
                <div className="space-y-2">
                  <Label htmlFor="email">Email*</Label>
                  <Input id="email" name="email" type="email" required />
                </div>
                <div className="space-y-2 relative">
                  <Label htmlFor="password">Password*</Label>
                  <Input
                    id="password"
                    name="password"
                    type={isShowPassword ? "text" : "password"}
                    required
                  />
                  <div
                    onClick={() => setIsShowPassword((p) => !p)}
                    className="absolute bottom-2 right-2 cursor-pointer"
              >
                    {!isShowPassword ? (
                      <EyeClosed size={"20"} />
                    ) : (
                      <EyeIcon size={"20"} />
                    )}
            </div>
                </div>
           
                 
                  <div className="space-y-2 w-full pt-4 ">
                    <Button
                      // onClick={handleCreatePatient}
                      type="submit"
                      variant={"default"}
                      size={"lg"}
                      disabled={ isLoading}
                      className="w-full"
                    >
                 
                      Sign In
                    </Button>
                  </div>
     
              </form> */}
              {/* <form onSubmit={handleLogin} className="space-y-6"> */}
              <RHFWrapper
                className="space-y-6"
                initialValues={{
                  email: "",
                  password: "",
                }}
                isValidate={true}
                validateSchema={
                  isForgetPassword
                    ? yup.object({
                        email: yup
  .string()
  .trim()
  .required("Email is required")
  .email("Email must be valid"),
                      })
                    : loginAs === "patient"
                      ? AuthSchema
                      : OtherAuthSchema
                }
                onSubmit={handleLogin}
              >
                {/* 1. Email/Mobile number section */}
                {isForgetPassword ? (
                  <RhfInput
                    defaultvalue=""
                    name={"email"}
                    type="email"
                    label="Email"
                    required={true}
                    placeholder="Enter email"
                    autoComplete="username"
                    trim
                  />
                ) :
                (loginAs === "patient" ? (
                  <>
                    {
                      <PatientOtpFields
                        onSendOtp={handleSendPatientOtp}
                        isSending={isSendingOtp}
                        disabled={isLoading}
                        // isOtpSent={isOtpSent}
                        loginViaPass={loginViaPass}
                        loginAs={loginAs}
                        setLoginViaPass={setLoginViaPass}
                        onEditContact={handleEditContact}
                        isOtpSent={isOtpSent}
                      />
                    }
                  </>
                ) : (
                  <RhfInput
                    defaultvalue=""
                    name={"email"}
                    type="email"
                    label="Email"
                    required={true}
                    placeholder="Enter email"
                    autoComplete="username"
                    trim
                  />
                ))
              }

                {/* 2. passoword section  */}
                {!isForgetPassword &&
                  (loginViaPass ? (
                    <RhfInput
                      defaultvalue=""
                      name={"password"}
                      type={"password"}
                      label="Password"
                      required={true}
                      placeholder={"Enter password"}
                      autoComplete="current-password"
                    />
                  ) : (
                    isOtpSent && (
                      <div className="space-y-4 mb-1">
                        <p className="text-sm text-muted-foreground flex items-start gap-2">
                          <span className="mt-0.5 shrink-0 inline-flex h-4 w-4 items-center justify-center rounded-full bg-blue-400 text-xs font-semibold text-blue-800">
                            !
                          </span>
                          <span>
                            Please check your mobile messages for the Passcode we sent
                            you.
                          </span>
                        </p>
                        <Input
                        className="mb-1"
                          value={patientOtp}
                          onChange={(event) => {
                            const digitsOnly = event.target.value
                              .replace(/\D/g, "")
                              .slice(0, 6);
                            setPatientOtp(digitsOnly);
                          }}
                          placeholder="Enter Passcode"
                          disabled={isVerifyingOtp}
                          inputMode="numeric"
                        />
                        <div className="flex items-end justify-between text-sm text-muted-foreground">
                          {resendAvailableIn > 0 ? (
                            <span className="ml-auto">
                              Resend Passcode in {formatCountdown(resendAvailableIn)}
                            </span>
                          ) : resendAttempt < resendSchedule.length ? (
                            <Button
                              type="button"
                              variant="link"
                              onClick={handleResendOtp}
                              disabled={isSendingOtp}
                              className="px-2 ml-auto"
                            >
                              {isSendingOtp ? "Resending..." : "Resend Passcode"}
                            </Button>
                          ) : (
                            <span>Resend limit reached</span>
                          )}
                        </div>
                      </div>
                    )
                  ))}

                {/* 3.fication codes and important notifications section  */}
                {!isForgetPassword && (loginViaPass || isOtpSent)  && (
                  <>
                    <div className="space-y-2 pt-1 text-xs text-muted-foreground">
                      <p>
                        By signing in, you agree to receive verification codes
                        and important notifications from Anthro Care.
                      </p>
                      <div className="flex items-start gap-2">
                        <Checkbox
                          id="login-terms"
                          className="mt-0.5"
                          checked={hasLoginConsent}
                          onCheckedChange={(checked) =>
                            setHasLoginConsent(checked === true)
                          }
                        />
                        <Label
                          htmlFor="login-terms"
                          className="text-xs font-normal flex flex-wrap text-muted-foreground whitespace-nowrap"
                        >
                          I agree to the{" "}
                          <a
                            href="https://anthro.care/terms-conditions/"
                            target="_blank"
                            rel="noreferrer"
                            className="underline text-primary"
                          >
                            Terms of Service
                          </a>{" "}
                          and{" "}
                          <a
                            href="https://anthro.care/privacy-policy/"
                            target="_blank"
                            rel="noreferrer"
                            className="underline text-primary"
                          >
                            Privacy Policy
                          </a>
                          .
                        </Label>
                      </div>
                    </div>
                  </>
                )}

                {/* 4. Button section -> submit pass/otp section */}
                {isOtpSent && !loginViaPass ? (
                  <Button
                    type="button"
                    variant="default"
                    size="lg"
                    disabled={
                      !isOtpSent || isVerifyingOtp || patientOtp.length < 6 || !hasLoginConsent
                    }
                    className="w-full"
                    onClick={handleVerifyPatientOtp}
                  >
                    Submit
                  </Button>
                ) : loginViaPass ? (
                  <><SignInButton
                    isLoading={isLoading}
                    isForgetPassword={isForgetPassword}
                    hasLoginConsent={hasLoginConsent}
                    lastSubmittedPassword={lastSubmittedPassword}
                  />
                  {error && (
  <div className="flex items-center gap-2 px-4 py-3 rounded-lg bg-red-50 border border-red-100 text-red-600 text-md">
    <AlertCircle className="w-5 h-5 shrink-0" />
    {error}
  </div>
)}
                  </>
                ) : (
                  <PatientSendOtpAction
                    onSendOtp={handleSendPatientOtp}
                    isSending={isSendingOtp}
                    disabled={isLoading || !hasLoginConsent}
                    hasLoginConsent={hasLoginConsent}
                  />
                )}

                <div className="flex justify-center">
                  {/* 3.fication codes and important notifications section  */}

                {!isForgetPassword && (
                  <div className="flex items-center justify-end">
                    {loginViaPass && (
                      <Button
                        type="button"
                        variant="link"
                        onClick={() => setIsForgetPAss((p) => !p)}
                      >
                        Forgot your password?
                      </Button>
                    )}
                  </div>
                )}

                  {isForgetPassword && (
                    <Button
                      variant="link"
                      type="button"
                      onClick={() => setIsForgetPAss((p) => !p)}
                      className="w-fit mx-auto text-center"
                    >
                      Already have an account? Sign in
                    </Button>
                  )}
                </div>
              </RHFWrapper>
            </CardContent>
          </Card>
        </div>
      </div>

      <TermsConditionsDialog
        open={isTermsOpen}
        setOpen={setIsTermsOpen}
        agreeTerms={handleAgreeTerms}
      />
    </>
  );
}

export default function AuthPage(props: AuthProps) {
  return (
    <Suspense>
      <Auth {...props} />
    </Suspense>
  );
}

const emailOrPhone = yup
  .string()
  .required("Email or phone is required")
  .test("email-or-phone", function (value) {
    const v = (value ?? "").trim();
    if (!v) return true; // required handles empty
    // If it's only digits (optionally with +, spaces, hyphens), treat as phone
    const phoneCandidate = v.replace(/[ \-()]/g, "");
    const looksLikePhone = /^[+]?\d+$/.test(phoneCandidate);
    if (looksLikePhone) {
      // adjust rule to your country/format:
      const isValidPhone = /^\+?\d{10,15}$/.test(phoneCandidate);
      return isValidPhone
        ? true
        : this.createError({ message: "Phone number must be valid" });
    }
    // Otherwise treat as email
    const isValidEmail = yup.string().email().isValidSync(v);
    return isValidEmail
      ? true
      : this.createError({ message: "Email must be valid" });
  });